import { AppRouteRecordRaw } from '@/router/types'

export const flowMonitoringManage: AppRouteRecordRaw[] = [
  {
    path: 'flowMonitoringManage',
    name: 'FlowMonitoringManage',
    component: () => import('@/views/flowMonitoringManage/index.vue'),
    meta: {
      title: '流程监控室'
    }
  }
]
